import * as React from "react";

import { Button } from "semantic-ui-react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { ApplicationState } from "../../applicationState";
import { TaskActionProps, GenericTaskActionProps } from "../model";

import { TaskConfirmationAction } from "./TaskConfirmationAction";

import { Link, push } from "redux-little-router";

const AppointmentMergePath = "mergedappointment";

export const TaskActionButton: React.FunctionComponent<TaskActionProps & GenericTaskActionProps> = (props: TaskActionProps & GenericTaskActionProps) => {
    const { task, taskRoute, onConfirmation, content, allowActionWhenCancelled } = props;
    const [openConfirmation, setOpenConfirmation] = React.useState<boolean>(false);

    const dispatch = useDispatch();

    const routeCustomerId = useSelector((state: ApplicationState) => state.router.params?.customerId);
    const routeOhCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    let basePath = useSelector((state: ApplicationState) => state.router.pathname);
    if (basePath?.endsWith("/")) {
        basePath = basePath.substring(0, basePath.length - 1);
    }

    let pathUrl: string = "";
    const basePathContainsCustomerId = !!routeCustomerId;
    const basePathContainsCaseId = !!routeOhCaseId;
    const containsMultipleAppointments = basePath?.includes(AppointmentMergePath) ?? false;

    if (containsMultipleAppointments) {
        const appointmentId = task.appointmentId;
        const customerId = task.customer.id;
        const ohCaseId = task.caseId;
        const taskId = task.id;

        pathUrl = `/book-appointments/appointment/${appointmentId}/${customerId}/${ohCaseId}/${taskId}/${taskRoute}`;
    } else {
        const customerIdUrlSection = basePathContainsCustomerId ? "" : `${task.customer.id}/`;
        const caseIdUrlSection = basePathContainsCaseId ? "" : `${task.caseId}/`;

        pathUrl = `${basePath}/${customerIdUrlSection}${caseIdUrlSection}${task.id}/${taskRoute}`;
    }

    const redirect = React.useCallback((href: string, newTab: boolean) => {
        if (newTab) {
            window.open(href, "_blank");
            return;
        }
        dispatch<any>(push(href));
    }, [dispatch]);

    const onOpenConfirmation = React.useCallback(() => setOpenConfirmation(true), []);
    const onCancelConfirmation = React.useCallback(() => setOpenConfirmation(false), []);
    const onConfirm = React.useCallback(() => {
        const newTab = containsMultipleAppointments;
        redirect(pathUrl, newTab);
    }, [containsMultipleAppointments, pathUrl, redirect]);

    if (task.didNotAttend || (task.cancelled && !allowActionWhenCancelled)) {
        return null;
    }

    return (
        <>
            {onConfirmation ?
                <>
                    <Button
                        content={content}
                        floated="right"
                        onClick={onOpenConfirmation}
                    />
                    <TaskConfirmationAction
                        openModal={openConfirmation}
                        onCancel={onCancelConfirmation}
                        onConfirm={onConfirm}
                        title={onConfirmation.title}
                        content={onConfirmation.content}>
                    </TaskConfirmationAction>
                </>
                :
                <Link
                    href={pathUrl}
                    target={containsMultipleAppointments ? "_blank" : ""}>
                    <Button
                        content={content}
                        floated="right"
                    />
                </Link>
            }
        </>
    );
};
